<div *ngFor="let org of selectableOrganizations" class="input">
  <input type="checkbox" (change)="updateOrganisatie(org)" [checked]="org.selected" /> <label>{{org.naam}}</label>
</div>
